<template>
  <div>
    <el-dialog title="选择地址" :before-close="handleCloes" :close-on-click-modal="false" :visible.sync="positionDialog" width="50%" destroy-on-close>
      <el-form :model="Mapform">
        <el-form-item :label-width="formLabelWidth" label="请输入地址">
          <el-input id="searchInput" @clear="handelclearInput" v-model="Mapform.mapText"></el-input>
        </el-form-item>
      </el-form>
      <div id="map-container"></div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handlePositionDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
window._AMapSecurityConfig = {
  // 真实值放 .env.production.local（不进仓库）；该 code 会打进前端包，真正的防护是控制台里的域名白名单
  securityJsCode: process.env.VUE_APP_AMAP_SECURITY_CODE || ""
};
export default {
  props: {
    positionDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formLabelWidth: "120px",
      Mapform: {
        mapText: ""
      },
      restaurants: [],

      map: null,
      mouseTool: null,
      overlays: [],
      auto: null,
      placeSearch: null,

      // 定位默认地址 | 搜索后选择的地址
      formattedAddress: null,
      // 地址对应的经纬度信息
      position: {
        lng: "",
        lat: ""
      },
      // 检索关键字
      searchValue: "",
      // 检索函数对象
      placeSearch: null,
      // 检索结果数据数据
      searchInfoList: [],
      // 地图标记
      marker: "",
      // 地址解析（正向）
      geocoder: "",
      // 地址名称
      name: "",
      adcode: "",
      defaultCity: "",

      auto: null,
      placeSearch: null,
      markers: [],
      position: {} //传给父组件的值【放经纬度和地址】
    };
  },
  watch: {
    // 监听事件 如果打开了弹框才加载地图，否则不加载地图
    positionDialog(type) {
      if (type) {
        // 确保DOM元素存在后再初始化地图
        this.$nextTick(() => {
          const mapContainer = document.getElementById('map-container');
          if (mapContainer) {
            this.Mapform.mapText = this.initAMap();
          }
        });
      }
    }
  },
  mounted() {
    this.initAMap();
  },
  beforeDestroy() {
    // 销毁地图
    this.map.destroy();
  },
  methods: {
    initAMap() {
      let _this = this;
      AMapLoader.reset()
      AMapLoader.load({
        key: "cf170904a2efa0d7eec902ce326a7806", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "1.4.15", // 指定要加载的 JS API 的版本，缺省时默认为 1.4.15
        plugins: [
          "AMap.Scale",
          "AMap.Geocoder",
          "AMap.ToolBar",
          "AMap.Bounds",
          "AMap.ControlBar",
          "AMap.MouseTool",
          "AMap.MapType",
          "AMap.HawkEye",
          "AMap.Autocomplete",
          "AMap.PlaceSearch"
        ] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then(AMap => {
          _this.map = new AMap.Map("map-container", {
            viewMode: "2D", //  是否为3D地图模式
            zoom: 13, // 初始化地图级别
            center: [104.064339, 30.555956], //中心点坐标  郑州
            resizeEnable: true
          });
          // 添加左下角的比例尺
          _this.map.addControl(new AMap.Scale());
          let toolBar = new AMap.ToolBar({
            position: {
              bottom: "21px",
              right: "35px"
            }
          });
          _this.map.setDefaultCursor("pointer");
          // 关键字查询
          _this.searchMap();
          // 鼠标点击获取经纬度
          _this.map.on("click", function (e) {
            _this.position.Lng = e.lnglat.getLng();
            _this.position.Lat = e.lnglat.getLat();
            _this.setMaker();
            const lnglat = [e.lnglat.getLng(), e.lnglat.getLat()];
            _this.geocoder.getAddress(lnglat, (status, result) => {
              if (status === "complete" && result.regeocode) {
                const res = result.regeocode;
                const {
                  adcode,
                  province,
                  city,
                  district
                } = res.addressComponent;
                _this.searchValue = res.formattedAddress;
                _this.Mapform.mapText = _this.searchValue;
                const name = province + city + district;
                const sdata = { adcode, lng: lnglat[0], lat: lnglat[1], name };
                // _this.searchSuccessData(sdata);
              } else {
                console.log(JSON.stringify(result));
              }
            });
          });
          _this.map.addControl(toolBar); // 添加右下角的放大缩小
        })
        .catch(e => {
          console.log(e);
        });
    },
    // 标点
    setMaker() {
      if (this.marker) {
        this.map.remove(this.marker);
      }
      this.marker = new AMap.Marker({
        position: [this.position.Lng, this.position.Lat]
      });
      this.map.add(this.marker);

      const bounds = new AMap.Bounds(
        [this.position.Lng - 0.01, this.position.Lat - 0.01],
        [this.position.Lng + 0.01, this.position.Lat + 0.01]
      );

      setTimeout(() => {
        this.map.setBounds(bounds);
      }, 100);

      this.geocoder = new AMap.Geocoder({
        city: this.defaultCity, // 默认：“全国”
        radius: 1000 // 范围，默认：500
      });
    },
    // 搜索
    searchMap() {
      this.$nextTick(() => {
        // 搜索框自动完成类
        this.auto = new AMap.Autocomplete({
          input: "searchInput" // 使用联想输入的input的id
        });
        //构造地点查询类
        this.placeSearch = new AMap.PlaceSearch({
          map: this.map,
          autoFitView: true
        });
        // 当选中某条搜索记录时触发
        this.auto.on("select", this.selectSite);
      });
    },
    //当选中某条搜索记录时触发
    selectSite(e) {
      if (e.poi.location) {
        this.position.Lng = e.poi.location.lng;
        this.position.Lat = e.poi.location.lat;
        this.setMaker();
        let _this = this;
        this.geocoder.getAddress(
          [e.poi.location.lng, e.poi.location.lat],
          function (status, result) {
            if (status === "complete" && result.regeocode) {
              _this.Mapform.mapText = result.regeocode.formattedAddress;
            }
          }
        );
      } else {
        this.$message.error("查询地址失败，请重新输入地址");
      }
    },

    // 清除input里的值，清除搜索结果，再次初始化map
    handelclearInput() {
      document.querySelector("#searchInput").innerHTML = "";
    },
    searchSuccessData(res) {
      this.formattedAddress = this.searchValue;
      this.adcode = res.adcode;
      this.name = res.name;
      this.position = { lng: res.lng, lat: res.lat };
      console.log(this.name, "this.name");
    },
    handleCancel() {
      this.$emit("updatePositionDialog", false);
    },
    handlePositionDialog() {
      if(!this.position.Lng || !this.position.Lat) return this.$message.error("请选择地址");
      this.$emit("handlePositionDialog", {
        longitude: this.position.Lng,
        latitude: this.position.Lat,
        mapText: this.Mapform.mapText
      });
    },
    handleCloes() {
      this.$emit("handleCloes", false);
    }
  }
};
</script>
<style>
#map-container {
  width: 100%;
  height: 400px;
  overflow: hidden;
}
</style>
